import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "stock-list" }
const _hoisted_2 = { class: "container-fluid pt-4 px-4" }
const _hoisted_3 = { class: "d-flex align-center flex-wrap ga-4" }
const _hoisted_4 = { class: "d-flex align-center ga-3" }
const _hoisted_5 = { class: "d-flex align-center ga-2" }
const _hoisted_6 = { class: "d-flex align-center ga-1" }
const _hoisted_7 = {
  key: 0,
  class: "panel-section",
  id: "stock-list-headers"
}
const _hoisted_8 = {
  key: 1,
  class: "panel-section",
  id: "stock-list-header-filters"
}
const _hoisted_9 = { class: "summary-row" }
const _hoisted_10 = { class: "d-flex flex-wrap ga-1" }
const _hoisted_11 = { class: "sub-row-wrap" }
const _hoisted_12 = ["colspan"]
const _hoisted_13 = { class: "sub-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_card, {
        flat: "",
        rounded: "lg",
        class: "stock-list-card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center flex-wrap ga-3 px-5 py-4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-h6 font-weight-medium" }, "Stock List", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_checkbox, {
                    modelValue: $data.advanced_filters,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.advanced_filters) = $event)),
                    value: 'only_free_stocks',
                    density: "compact",
                    "hide-details": "",
                    label: "Only Free Stocks"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_checkbox, {
                    modelValue: $data.advanced_filters,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.advanced_filters) = $event)),
                    value: 'only_portfolio_stocks',
                    density: "compact",
                    "hide-details": "",
                    label: "Only Portfolio Stocks"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "tonal",
                    rounded: "lg",
                    size: "small",
                    onClick: $options.applyFilters
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Search ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    rounded: "lg",
                    size: "small",
                    onClick: $options.resetFilters
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" Reset ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  size: "small",
                  rounded: "lg",
                  onClick: $options.toggleExpand,
                  title: "Column Select"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'table-columns'] })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  size: "small",
                  rounded: "lg",
                  onClick: $options.toggleFilterExpand,
                  title: "Filter"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'filter'] })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  size: "small",
                  rounded: "lg",
                  color: "primary",
                  onClick: $options.exportToExcel,
                  title: "Export CSV"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { icon: "mdi-download" })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }),
          ($data.isExpanded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.grid.headers, (header, index) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        key: index,
                        cols: "12",
                        sm: "6",
                        md: "3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            modelValue: $data.selected_columns,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.selected_columns) = $event)),
                            value: header.key,
                            flat: "",
                            class: "d-flex",
                            label: header.title,
                            placeholder: header.title
                          }, null, 8, ["modelValue", "value", "label", "placeholder"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          ($data.isFilterExpanded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_v_row, { dense: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.grid.headers, (header, index) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        key: index,
                        cols: "12",
                        sm: "6",
                        md: "4",
                        lg: "3"
                      }, {
                        default: _withCtx(() => [
                          ($options.getFilterComponent(header.filterType))
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent($options.getFilterComponent(header.filterType)), {
                                key: 0,
                                modelValue: $data.grid.filters[header.key],
                                "onUpdate:modelValue": ($event: any) => (($data.grid.filters[header.key]) = $event),
                                options: $data.filterOptions[header.key] || [],
                                label: header.title,
                                sort: header.sort,
                                order: header.order
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "sort", "order"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_data_table, {
            expanded: $data.expanded,
            "onUpdate:expanded": _cache[3] || (_cache[3] = ($event: any) => (($data.expanded) = $event)),
            headers: $options.filteredHeaders,
            items: $data.stockListPlatformWise.stockData,
            "item-value": "name",
            "show-expand": "",
            "fixed-header": "",
            "items-per-page-options": [10, 15, 20, 30, 50, 100, 200],
            "items-per-page": 5,
            class: "custom-data-table"
          }, {
            thead: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredHeaders, (header, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString($options.getSummaryValue(header.key)), 1))
                  }), 128))
                ])
              ])
            ]),
            [`item.code`]: _withCtx(({ item }) => [
              _createVNode(_component_router_link, {
                target: "_blank",
                name: "stock-view",
                to: { path: '/stock/view', query: { id: item.code } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.code), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            [`item.market_price`]: _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatPrice(item.market_price)), 1)
            ]),
            [`item.avg_price`]: _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatPrice(item.avg_price)), 1)
            ]),
            [`item.investment`]: _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatPrice(item.investment)), 1)
            ]),
            [`item.current_value`]: _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatPrice(item.current_value)), 1)
            ]),
            [`item.profit_loss`]: _withCtx(({ item }) => [
              _createElementVNode("span", {
                class: _normalizeClass(item.profit_loss >= 0 ? 'text-success' : 'text-error')
              }, _toDisplayString(_ctx.$helper.formatPrice(item.profit_loss)), 3)
            ]),
            [`item.profit_loss_per`]: _withCtx(({ item }) => [
              _createElementVNode("span", {
                class: _normalizeClass(item.profit_loss_per >= 0 ? 'text-success' : 'text-error')
              }, _toDisplayString(_ctx.$helper.formatPercentage(item.profit_loss_per)), 3)
            ]),
            [`item.perches_date`]: _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatDate(item.perches_date, true)), 1)
            ]),
            [`item.updated_at`]: _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatDate(item.updated_at, true)), 1)
            ]),
            [`item.percentage_to_sell`]: _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatPercentage(item.percentage_to_sell / 100)), 1)
            ]),
            [`item.indices`]: _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.indices, (idx) => {
                  return (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: idx.code,
                    location: "top"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_chip, _mergeProps({ ref_for: true }, props, {
                        size: "x-small",
                        variant: idx.membership_type === 'constituent' ? 'flat' : 'outlined',
                        color: idx.membership_type === 'constituent' ? 'primary' : 'default'
                      }), {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(idx.name), 1)
                        ]),
                        _: 2
                      }, 1040, ["variant", "color"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(idx.comments || (idx.membership_type === 'constituent' ? 'Verified index constituent' : 'Sector-linked, not a verified constituent')), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]),
            "expanded-row": _withCtx(({ columns, item }) => [
              _createElementVNode("tr", _hoisted_11, [
                _createElementVNode("td", {
                  colspan: columns.length
                }, [
                  _createElementVNode("table", _hoisted_13, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredSubHeaders, (field, key) => {
                          return (_openBlock(), _createElementBlock("th", { key: key }, _toDisplayString(field.title), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.stock, (rows) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: rows.stock_id
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredSubHeaders, (field, key) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: key,
                              class: _normalizeClass(["sub-cell", {
                          'text-success': ['profit_loss', 'profit_loss_per'].includes(field.key) && rows[field.key] >= 0,
                          'text-error': ['profit_loss', 'profit_loss_per'].includes(field.key) && rows[field.key] < 0,
                        }])
                            }, [
                              (field.key === 'name')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("span", {
                                      class: "platform-dot",
                                      style: _normalizeStyle({ 'background-color': $options.getPlatformColor(rows.platform_id) })
                                    }, null, 4),
                                    _createTextVNode(" " + _toDisplayString($options.getPlatformName(rows.platform_id)), 1)
                                  ], 64))
                                : (['investment', 'avg_price', 'market_price', 'profit_loss', 'current_value'].includes(field.key))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$helper.formatPrice(rows[field.key])), 1)
                                    ], 64))
                                  : (field.key === 'profit_loss_per')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$helper.formatPercentage(rows[field.key])), 1)
                                      ], 64))
                                    : (field.key === 'percentage_to_sell')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$helper.formatPercentage(rows[field.key] / 100)), 1)
                                        ], 64))
                                      : (['perches_date', 'updated_at'].includes(field.key))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$helper.formatDate(rows[field.key], true, true) || ''), 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                            _createTextVNode(_toDisplayString(rows[field.key] != null ? String(rows[field.key]).replace(/,/g, '') : ''), 1)
                                          ], 64))
                            ], 2))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ])
                ], 8, _hoisted_12)
              ])
            ]),
            _: 2
          }, 1032, ["expanded", "headers", "items"])
        ]),
        _: 1
      })
    ])
  ]))
}